module.exports = __webpack_public_path__ + "static/media/hot72.35658b33.jpg";